import React from 'react';
import { CarteModificationBase } from './CarteModificationBase';
import { t } from '../i18n';
import type { LetterChange } from '../types';

export interface CarteModificationLettreProps {
  change: LetterChange;
  retenue: boolean;
  onToggle: (retenue: boolean) => void;
  // Figé pendant l'enregistrement : on ne change plus ce qui est en train d'être appliqué.
  disabled?: boolean;
  testID?: string;
}

/**
 * Une modification de la lettre : l'objet, ou un paragraphe désigné par son rang (« Paragraphe 2 »,
 * à partir de 1 pour la personne, alors que le serveur compte à partir de 0).
 */
export function CarteModificationLettre({ change, retenue, onToggle, disabled = false, testID = 'modif' }: CarteModificationLettreProps) {
  const tag = t(`coverLetterImprove.tags.${change.tag}`);
  const emplacement =
    change.target === 'subject'
      ? t('coverLetterImprove.modif.objet')
      : t('coverLetterImprove.modif.paragraphe', { numero: (change.paragraph ?? 0) + 1 });
  // Début du nouveau texte : deux paragraphes de la même nature se distinguent au lecteur d'écran.
  const extrait = change.after.length > 40 ? `${change.after.slice(0, 40).trimEnd()}…` : change.after;
  const nom = [tag, emplacement, extrait].join(', ');
  return (
    <CarteModificationBase
      testID={testID}
      tag={tag}
      lieu={emplacement}
      reason={change.reason}
      before={change.before}
      after={change.after}
      nomInterrupteur={t('coverLetterImprove.modif.appliquer', { nom })}
      retenue={retenue}
      onToggle={onToggle}
      disabled={disabled}
    />
  );
}
